import { LocDefs, LocMap } from '@cm/core/localization';
import { pathStart, sharedProperties } from '../../models/score-report-delay-locs';

export type SPSettingsScoreReportDelaySettingsLocNames =
	| 'SPSettingsScoreReportDelaySettingsTitle'
	| 'SPSettingsScoreReportDelaySettingsAddSuccess'
	| 'SPSettingsScoreReportDelaySettingsEditSuccess'
	| 'SPSettingsScoreReportDelaySettingsDeleteSuccess'
	| 'SPSettingsScoreReportDelaySettingsDeleteFailureSome'
	| 'SPSettingsScoreReportDelaySettingsDeleteFailureAll'
	| 'SPSettingsScoreReportDelaySettingsAddButton'
	| 'SPSettingsScoreReportDelaySettingsEditButton'
	| 'SPSettingsScoreReportDelaySettingsDeleteButton'
	| 'SPSettingsScoreReportDelaySettingsJurisdictionField'
	| 'SPSettingsScoreReportDelaySettingsDelayField';

export const spSettingsScoreReportDelaySettingsLocs: LocDefs<SPSettingsScoreReportDelaySettingsLocNames> =
	{
		SPSettingsScoreReportDelaySettingsTitle: {
			defaultValue: 'Exam Score Report Delay Settings',
			description: 'Section title for the delay settings.',
			displayPath: `${pathStart}Delay Settings|Section Title`,
			displayType: 'Title',
			...sharedProperties,
		},
		SPSettingsScoreReportDelaySettingsAddSuccess: {
			defaultValue: 'Score report delay successfully added.',
			description: 'Success message for adding delay settings.',
			displayPath: `${pathStart}Delay Settings|Add Success`,
			displayType: 'Content',
			...sharedProperties,
		},
		SPSettingsScoreReportDelaySettingsEditSuccess: {
			defaultValue: 'Score report delay successfully updated.',
			description: 'Success message for updating delay settings.',
			displayPath: `${pathStart}Delay Settings|Edit Success`,
			displayType: 'Content',
			...sharedProperties,
		},
		SPSettingsScoreReportDelaySettingsDeleteSuccess: {
			defaultValue: 'Score report delay(s) successfully deleted.',
			description: 'Success message for deleting delay settings.',
			displayPath: `${pathStart}Delay Settings|Delete Success`,
			displayType: 'Content',
			...sharedProperties,
		},
		SPSettingsScoreReportDelaySettingsDeleteFailureSome: {
			defaultValue: 'Some score report delay(s) failed to delete.',
			description: 'Failure message for deleting delay settings when some fail.',
			displayPath: `${pathStart}Delay Settings|Delete Failure Some`,
			displayType: 'Content',
			...sharedProperties,
		},
		SPSettingsScoreReportDelaySettingsDeleteFailureAll: {
			defaultValue: 'All score report delay(s) failed to delete.',
			description: 'Failure message for deleting delay settings when all fail.',
			displayPath: `${pathStart}Delay Settings|Delete Failure All`,
			displayType: 'Content',
			...sharedProperties,
		},
		SPSettingsScoreReportDelaySettingsAddButton: {
			defaultValue: 'Add Delay Settings',
			description: 'Button to add a delay setting.',
			displayPath: `${pathStart}Delay Settings|Add Button`,
			displayType: 'Button',
			...sharedProperties,
		},
		SPSettingsScoreReportDelaySettingsEditButton: {
			defaultValue: 'Edit Setting',
			description: 'Button to edit a delay setting.',
			displayPath: `${pathStart}Delay Settings|Edit Button`,
			displayType: 'Button',
			...sharedProperties,
		},
		SPSettingsScoreReportDelaySettingsDeleteButton: {
			defaultValue: 'Delete Selected Setting(s)',
			description: 'Button to delete the selected setting(s).',
			displayPath: `${pathStart}Delay Settings|Delete Button`,
			displayType: 'Button',
			...sharedProperties,
		},
		SPSettingsScoreReportDelaySettingsJurisdictionField: {
			defaultValue: 'Jurisdiction',
			description: 'Field label for jurisdiction.',
			displayPath: `${pathStart}Delay Settings|Jurisdiction Field`,
			displayType: 'Label',
			...sharedProperties,
		},
		SPSettingsScoreReportDelaySettingsDelayField: {
			defaultValue: 'Delay (in days)',
			description: 'Field label for delay.',
			displayPath: `${pathStart}Delay Settings|Delay Field`,
			displayType: 'Label',
			...sharedProperties,
		},
	};

export type SPSettingsScoreReportDelaySettingsLocType =
	LocMap<SPSettingsScoreReportDelaySettingsLocNames>;
